import React from "react";
import { createContext, useState, useEffect, useContext } from "react";
import { auth } from "../database/firebase";
import { onAuthStateChanged } from "firebase/auth";
import { db } from "../database/firebase";
import { doc, getDoc } from "firebase/firestore";

const AuthContext = createContext({});

export const useAuth = () => {
  return useContext(AuthContext);
};

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [userLoggedIn, setUserLoggedIn] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function initializeUser(user) {
      if (user) {
        let rol;
        try {
          rol = await getRol(user);
        } catch {
          console.log("Error al obtener el rol del usuario");
          rol = "usuario";
        }
        setCurrentUser({ ...user, rol });
        setUserLoggedIn(true);
      } else {
        setCurrentUser(null);
        setUserLoggedIn(false);
      }
      setLoading(false);
    }
    const unsubscribe = onAuthStateChanged(auth, initializeUser);
    return unsubscribe;
  }, []);

  async function getRol(currentUser) {
    try {
      if (auth.currentUser) {
        console.log("está autenticado");
        const docRef = doc(db, "usuarios", currentUser.uid);
        const docCifrada = await getDoc(docRef);
        console.log("docCifrada", docCifrada.data());
        let rol = docCifrada.data()?.rol;
        console.log("rol:" + rol);
        if (rol === undefined) {
          // Si el rol es undefined, busca en la colección 'usuariosAdmin'
          console.log("Buscando en la colección de usuarios Admin");
          const docRefAdm = doc(db, "usuariosAdmin", currentUser.uid);
          const docCifradaAdm = await getDoc(docRefAdm);
          console.log("docCifradaAdm", docCifradaAdm.data());
          rol = docCifradaAdm.data()?.rol;
        }
        console.log("rol:" + rol);
        return rol;
      } else {
        console.log("no está autenticado");
        return null;
      }
    } catch (error) {
      console.log(error);
    }
  }

  const value = {
    currentUser,
    setCurrentUser,
    userLoggedIn,
    loading,
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
};
